import { useTranslations } from '@vocab/react';
import { Box, Loader, Stack, Heading, Text, Badge } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import { useRef } from 'react';

import { ReferenceDetailsViewer } from 'src/components/References/ReferenceDetailsViewer';
import { useReferenceChecks } from 'src/context/useReferenceChecks';
import {
  EditorDrawer,
  EditorDrawerProvider,
} from 'src/ui/EditorDrawer/EditorDrawer';

import {
  LOCAL_STORAGE_KEY,
  ReferencesList,
} from '../../../../components/References/ReferencesList';

import translations from './.vocab';

export const References = () => {
  const { t } = useTranslations(translations);
  const scrollRef = useRef<HTMLDivElement>(null);
  const isReferenceSelected = localStorage.getItem(LOCAL_STORAGE_KEY);
  const { data, loading, error } = useReferenceChecks();
  const referenceChecks = data?.viewer?.referenceChecks || [];

  if (loading) {
    return <Loader />;
  }
  if (referenceChecks.length === 0 || error) {
    return null;
  }
  return (
    <EditorDrawerProvider name="references">
      <Box
        ref={scrollRef}
        style={{ scrollMarginTop: vars.space.xxlarge }}
        data={{ automation: 'references-section', testid: 'references-card' }}
      >
        {referenceChecks && (
          <Stack space="large">
            <Stack space="small">
              {!isReferenceSelected && (
                <Badge tone="positive">{t('New')}</Badge>
              )}
              <Heading level="3">{t('References')}</Heading>
            </Stack>
            <Text tone="secondary">
              {t('Include reference checks to help')}
            </Text>
            <ReferencesList referenceChecks={referenceChecks} />
          </Stack>
        )}
      </Box>
      <EditorDrawer
        name="references"
        title={t('References')}
        onClose={() => {
          scrollRef.current?.scrollIntoView?.({
            behavior: 'smooth',
            block: 'start',
          });
        }}
      >
        <ReferenceDetailsViewer referenceChecks={referenceChecks} />
      </EditorDrawer>
    </EditorDrawerProvider>
  );
};
